/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav, Form } from 'react-bootstrap';
import classNames from 'classnames';
import AppContext from 'context/Context';
import Logo from 'components/common/Logo';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { jwtDecode } from 'jwt-decode';
import { getTenantFromToken } from 'utils/routeUtils';

const NavbarTop = ({
  locationData,
  showDropdown,
  dropdownDisabled,
  locationLoading
}) => {
  const {
    config: { showBurgerMenu, navbarPosition, navbarCollapsed },
    setConfig
  } = useContext(AppContext);

  const tenant = getTenantFromToken();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isChat = pathname.includes('chat');
  const isEvaluate = pathname.includes('evaluate');
  const isPlotOverlay = pathname.includes('plotoverlay');
  const isHabitat = pathname.includes('habitat');

  const [showDropShadow, setShowDropShadow] = useState(false);

  const handleBurgerMenu = () => {
    (navbarPosition === 'top' || navbarPosition === 'double-top') &&
      setConfig('navbarCollapsed', !navbarCollapsed);
    (navbarPosition === 'vertical' || navbarPosition === 'combo') &&
      setConfig('showBurgerMenu', !showBurgerMenu);
  };

  const setDropShadow = () => {
    const el = document.documentElement;
    if (el.scrollTop > 0) {
      setShowDropShadow(true);
    } else {
      setShowDropShadow(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', setDropShadow);
    return () => window.removeEventListener('scroll', setDropShadow);
  }, []);

  const burgerMenuRef = useRef();

  const handleChange = ({ target }) => {
    setConfig('cluster', target.value);
    if (isPlotOverlay) {
      navigate(`/${tenant}/plotoverlay/${target.value}`);
    } else if (isHabitat) {
      navigate(`/${tenant}/habitat/${target.value}`);
    } else {
      navigate(
        `/${tenant}/${isEvaluate ? 'evaluate' : 'monitor'}/${target.value}`
      );
    }
  };

  return (
    <Navbar
      className={classNames('navbar-glass fs--1 navbar-top sticky-kit', {
        // 'navbar-glass-shadow': showDropShadow
        'navbar-glass-shadow': showDropShadow && !isChat
      })}
      expand={
        navbarPosition === 'top' ||
        navbarPosition === 'combo' ||
        navbarPosition === 'double-top'
          ? topNavbarBreakpoint
          : true
      }
    >
      {navbarPosition === 'double-top' ? (
        <div className="w-100">
          <div className="d-flex flex-between-center">
            <NavbarTopElements
              navbarCollapsed={navbarCollapsed}
              navbarPosition={navbarPosition}
              handleBurgerMenu={handleBurgerMenu}
              burgerMenuRef={burgerMenuRef}
              handleChange={handleChange}
              locationData={locationData}
              showDropdown={showDropdown}
              dropdownDisabled={dropdownDisabled}
              locationLoading={locationLoading}
            />
          </div>
          <hr className="my-2 d-none d-lg-block" />
          <Navbar.Collapse in={navbarCollapsed} className="scrollbar py-2">
            <Nav navbar>
              <NavbarTopDropDownMenus />
            </Nav>
          </Navbar.Collapse>
        </div>
      ) : (
        <NavbarTopElements
          navbarCollapsed={navbarCollapsed}
          navbarPosition={navbarPosition}
          handleBurgerMenu={handleBurgerMenu}
          burgerMenuRef={burgerMenuRef}
          handleChange={handleChange}
          locationData={locationData}
          showDropdown={showDropdown}
          dropdownDisabled={dropdownDisabled}
          locationLoading={locationLoading}
        />
      )}
    </Navbar>
  );
};

const NavbarTopElements = ({
  navbarPosition,
  handleBurgerMenu,
  navbarCollapsed,
  handleChange,
  locationData,
  showDropdown,
  dropdownDisabled,
  locationLoading
}) => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  const burgerMenuRef = useRef();
  const { cluster } = useParams();

  const [options, setOptions] = useState(null);

  useEffect(() => {
    if (locationLoading) {
      setOptions(<option disabled>Loading....</option>);
    } else if (isEmpty(locationData)) {
      setOptions(<option disabled>No clusters found.</option>);
    } else {
      setOptions(
        locationData.map(item => (
          <option key={item.key} value={item.key}>
            {item.value}
          </option>
        ))
      );
    }
  }, [locationData, dropdownDisabled, locationLoading]);

  let selectElement = null;
  if (showDropdown) {
    selectElement = (
      <Form.Select
        name="cluster"
        // className={classNames({
        //   'bg-white': !isDark,
        //   'opacity-75': !isDark && dropdownDisabled
        // })}
        disabled={dropdownDisabled}
        value={locationData.some(item => item.key === cluster) ? cluster : ''}
        onChange={handleChange}
        style={{ minWidth: '21.5rem' }}
      >
        <option key="blankChoice" hidden value>
          Select a Cluster
        </option>
        {options}
      </Form.Select>
    );
  }

  return (
    <>
      <Navbar.Toggle
        ref={burgerMenuRef}
        className={classNames('toggle-icon-wrapper me-md-3 me-2', {
          'd-lg-none':
            navbarPosition === 'top' || navbarPosition === 'double-top',
          [`d-${navbarBreakPoint}-none`]:
            navbarPosition === 'vertical' || navbarPosition === 'combo'
        })}
        as="div"
      >
        <button
          className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
          onClick={handleBurgerMenu}
          id="burgerMenu"
        >
          <span className="navbar-toggle-icon">
            <span className="toggle-line" />
          </span>
        </button>
      </Navbar.Toggle>

      <Logo at="navbar-top" width={40} id="topLogo" />

      {navbarPosition === 'top' || navbarPosition === 'combo' ? (
        <Navbar.Collapse
          in={navbarCollapsed}
          className="scrollbar pb-3 pb-lg-0"
        >
          <Nav navbar>
            <NavbarTopDropDownMenus />
          </Nav>
        </Navbar.Collapse>
      ) : (
        <Nav
          navbar
          className={`align-items-center d-none d-${topNavbarBreakpoint}-block`}
          as="ul"
        >
          <Nav.Item as="li">{selectElement}</Nav.Item>
        </Nav>
      )}
      <TopNavRightSideNavItem />
    </>
  );
};

NavbarTopElements.propTypes = {
  navbarPosition: PropTypes.string,
  handleBurgerMenu: PropTypes.func,
  navbarCollapsed: PropTypes.bool
};
export default NavbarTop;
